'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 联系人
 */
var AvatarMobile = React.createClass({
  render: function () {
    return (<div className="avatar-content">
      <div className="background">
        <img src={assetsHelper.getComponentAsset('Avatar(Mobile)')}
        />
      </div>
      <div className="triangle"/>
    </div>);
  }
});

module.exports = AvatarMobile;



// WEBPACK FOOTER //
// ./src/views/Components/AvatarMobile.jsx